import $http from '../../../axios-instance';
import Swal from 'sweetalert2';
const moment = require('moment');

export async function obtenerLicencias({commit, dispatch, state, rootState}) {
  commit('dashboard/load', true, {root: true});

  commit('establerIdEmpresaFiltros', rootState.empresa.selectedEmpresa.id);

  const parametros = {params: state.filtros};

  await $http.get(`empresas/licencias`, parametros)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      commit('establecerLicencias', response.data.licencias);
    })
    .catch(async (error) => {
      console.log(error);
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, mensaje: error});
    });
}

export async function obtenerModalidadesDePago({commit, dispatch, state, rootState}) {
  commit('dashboard/load', true, {root: true});
  await $http.get(`adm_general/listas/codigo-control/001fdp`)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      commit('establecerFormasDePago', response.data.data);
    })
    .catch(async (error) => {
      console.log(error);
      commit('dashboard/load', false, {root: true});
    });
}


/*
export async function licenciasPorCaducar({commit, dispatch, state}) {


  const parametros = {params: state.licencia};

  await $http.get(`empresas/licencias`, parametros)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      let alerta = false
      let licencias = response.data.licencias.data
      let dias = []
      for(let i = 0; i < licencias.length; i++){
        if(licencias[i].alarma == 1 && licencias[i].vigencia == "Vigente"){
          dias.push(licencias[i].dias_restantes.split(" ")[0])
          alerta = true

        }
      }

      let menor = Math.min(...dias)

      if(alerta){
        await Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Una de sus licencias está por expirar',
          text: 'Quedan '+menor+' dias para que su licencia expire',
          showConfirmButton: true,
          timer: 5000
        });
      }

    })
    .catch(async (error) => {
      console.log(error);

      await dispatch('mostrarMensaje', {error: true, mensaje: error});
    });

}*/


export async function obtenerLicencia({commit, dispatch, rootState}, id) {
  commit('dashboard/load', true, {root: true});

  const id_empresa = rootState.empresa.selectedEmpresa.id;

  await $http.get(`empresas/licencias/${id}/${id_empresa}`)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      commit('establecerLicencia', response.data.licencia);
    })
    .catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, mensaje: error});
    });
}

export async function crearLicencia({commit, state, dispatch, rootState}) {
  commit('dashboard/load', true, {root: true});

  commit('establerIdEmpresaLicencia', rootState.empresa.selectedEmpresa.id);
  commit('establerFechasLicencia');

  await $http.post(`empresas/licencias/crear`, state.licencia)
    .then(async (response) => {

      commit('establecerModalVer', false);
      commit('resetLicencia');
      commit('resetFiltros');
      await dispatch('obtenerLicencias');

      commit('dashboard/load', false, {root: true});

      await dispatch('mostrarMensaje', {error: false, mensaje: response.data.message});
    })
    .catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, mensaje: error});
    });
}

export async function actualizarLicencia({commit, state, dispatch}) {
  commit('dashboard/load', true, {root: true});

  commit('establerFechasLicencia');

  await $http.put(`empresas/licencias/actualizar/${state.licencia.id}`, state.licencia)
    .then(async (response) => {

      commit('establecerModalVer', false);
      commit('resetLicencia');
      commit('resetFiltros');
      await dispatch('obtenerLicencias');

      commit('dashboard/load', false, {root: true});

      await dispatch('mostrarMensaje', {error: false, mensaje: response.data.message});
    })
    .catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, mensaje: error});
    });
}

export async function cambiarEstado({commit, dispatch, rootState}, id) {

  await Swal.fire({
    title: 'Inactivar',
    text: '¿Está seguro de cambiar el estado de la licencia?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'Cancelar',
    confirmButtonText: 'Si'
  }).then(async (result) => {
    if (result.value) {

      commit('dashboard/load', true, {root: true});

      const id_empresa = rootState.empresa.selectedEmpresa.id;

      await $http.delete(`empresas/licencias/cambiar-estado/${id}/${id_empresa}`)
        .then(async (response) => {
          commit('dashboard/load', false, {root: true});
          commit('resetFiltros');
          await dispatch('obtenerLicencias');
          await dispatch('mostrarMensaje', {error: false, mensaje: response.data.message});
        })
        .catch(async (error) => {
          commit('dashboard/load', false, {root: true});
          await dispatch('mostrarMensaje', {error: true, mensaje: error});
        });
    }
  });
}

export async function mostrarMensaje({}, {error, mensaje}) {
  if (error) {
    let texto = [];

    if (mensaje.status === 422 && mensaje.errors) {
      const errores = mensaje.errors;
      for (const llave in errores) {
        if (errores[llave] && errores[llave][0]) {
          texto.push(errores[llave][0]);
        }
      }
      mensaje = texto.join('\n');
    } else if (mensaje.errors) {
      const errores = mensaje.errors;
      for (const llave in errores) {
        if (errores[llave] && errores[llave]) {
          texto.push(errores[llave]);
        }
      }
      mensaje = texto.join('\n');
    } else {
      mensaje = mensaje.message;
    }
  }

  await Swal.fire({
    position: 'center',
    icon: error ? 'error' : 'success',
    title: error ? 'Error' : 'Muy bien!',
    text: mensaje,
    showConfirmButton: true,
    timer: 3000
  });
}

export async function obtenerEmpresas({commit, state}) {

  commit('dashboard/load', true, {root: true});

  await $http.get('/empresas/lista')
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('establecerEmpresas', response.data.data);
    })
    .catch(() => {
      commit('dashboard/load', false, {root: true});
    });
}

export async function descargarReporte({state, commit, dispatch}) {

  commit('dashboard/load', true, {root: true});

  const nombre = 'Reporte_licenciamiento_SOLUQUIM_' + moment().format('yyyyMMDD') + '.xlsx';

  await $http({
    url: `empresas/licencias/generar-reporte`,
    method: 'GET',
    responseType: 'blob',
    params: state.reporte
  }).then(async (response) => {
    window.downloadFile(response.data,nombre);
    commit('dashboard/load', false, {root: true});
  }).catch(async (error) => {
    commit('dashboard/load', false, {root: true});
    await dispatch('mostrarMensaje', {error: true, mensaje: 'Error al generar el reporte'});
  });

}

/**
 * Cargar responsables para asignar a las licencias.
 *
 * @param {*} commit
 * @param array {*} license: datos del parametro de busqueda y el id de la empresa
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function loadResponsibles({ commit }, license) {

  commit('dashboard/load', true, {root: true});
  await $http.post('companies/licenses/get-responsibles', {
    companyId: license.companyId,
    param: license.responsible_user
  })
    .then(({ data: response }) => commit('setResponsibles', response.data))
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al tratar de cargar los responsables.',
        showConfirmButton: false,
        timer: 1500
      })
    }).finally(() => commit('dashboard/load', false, { root: true }));

}

/**
 * Verificar si la licencia ha sido aprobada.
 *
 * @param {*} commit
 * @param array {*} license: companyId y el id del usuario activo
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function checkSystemLicenseIsApproved({ commit }, license) {

    commit('dashboard/load', true, { root: true });
    await $http.get(`companies/licenses/checkApprovalStatus/${license.companyId}`)
        .then(({ data: response }) => {
            if (response.code_response == 200) {

                commit('establecerLicencia', response.license);

                if (license.userActiveId == response.license.responsible_user_id) {
                    commit('setModalAcceptLicense', true);
                    commit('establecerLicencia', response.license);
                    commit('setPaymentMethods', response.paymentModalities);
                }

            }
        })
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error al tratar de cargar el estado de la licencia.',
                showConfirmButton: false,
                timer: 1500
            })
        }).finally(() => commit('dashboard/load', false, { root: true }));

}

/**
 * Cambiar el estado de la licencia a aprobada por el responsable.
 *
 * @param {*} commit
 * @param array {*} license: companyId y el id del usuario activo
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function licenseApproved({ commit }, license) {

    commit('dashboard/load', true, { root: true });
    await $http.put(`companies/licenses/contract-approved/${license.companyId}/${license.id}`)
        .then(({ data: response }) => {

            if (response.code_response == 200) {
                commit('establecerLicencia', response.license);
                commit('setModalDetailsLicence', false);
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.message,
                    showConfirmButton: true,
                })
            }

            else if (response.code_response == 204) {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: response.message,
                    showConfirmButton: false,
                })
            }

            else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error al tratar aceptar el contrato de la licencia.',
                    showConfirmButton: false,
                    timer: 1500
                })
            }

        })
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error al tratar aceptar el contrato de la licencia.',
                showConfirmButton: false,
                timer: 1500
            })
        }).finally(() => commit('dashboard/load', false, { root: true }));

}


/**
 * Guardar datos del contrato de licencia para uso de Soluquim por empresa.
 *
 * @param object {*} company: empresa
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function storeLicensingContract({ commit }, company) {

  commit('dashboard/load', true, { root: true });
  await $http.put(`companies/licenses/licensing-contract/${company.id}`, {
    licensingContract: company.licensing_contract
  })
    .then(({ data: response }) => {

      if (response.code_response == 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Contrato de licenciamiento',
          text: response.message,
          showConfirmButton: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'info',
          title: 'Contrato de licenciamiento',
          text: response.message,
          showConfirmButton: false,
        })
      }

    })
    .catch(() => {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Contrato de licenciamiento',
        showConfirmButton: false,
      })
    }).finally(() => commit('dashboard/load', false, { root: true }));

}

